import { render, staticRenderFns } from "./index1027.vue?vue&type=template&id=d50cd38a&scoped=true&"
import script from "./index1027.vue?vue&type=script&lang=js&"
export * from "./index1027.vue?vue&type=script&lang=js&"
import style0 from "./index1027.vue?vue&type=style&index=0&id=d50cd38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50cd38a",
  null
  
)

export default component.exports